"use client";

import Image from "next/image";
import style from "./style.module.scss";
import { IMAGE_PATHS, GENERAL, UI_TEXT } from "@/constants";

const NoDataSection = () => {
  return (
    <div className={style.noDataSection}>
      <Image
        src={IMAGE_PATHS.ICONS.NO_DATA}
        alt="no data"
        width={GENERAL.IMAGE_SIZES.NO_DATA_WIDTH}
        height={GENERAL.IMAGE_SIZES.NO_DATA_HEIGHT}
      />
      <div className={style.noDataContent}>
        <p className={style.noDataTitle}>
          {UI_TEXT.LABELS.NO_INFORMATION_AVAILABLE}
        </p>
        <p className={style.noDataDescription}>
          {UI_TEXT.LABELS.NO_INFORMATION_DESCRIPTION}
        </p>
      </div>
    </div>
  );
};

export default NoDataSection;
